import { Button, Grid, MenuItem } from '@mui/material';
import { useField, useFormikContext } from 'formik';
import { ChangeEvent } from 'react';

import { shouldBeEmail } from '@jebel/utils';

import { FormSelect, FormTextField } from 'shared/components/ui';
import { FIELDS_CONFIG_USER } from 'shared/constants';
import { UserInvitationParsed } from 'shared/hooks';

import { Container, HeaderText, Header } from './StyledComponents';

interface Props {
  index: number;
  name: string;
  onRemove: () => void;
}

const mapToMenuItem = (item: { label: string; value: string }) => (
  <MenuItem key={item.value} value={item.value}>
    {item.label}
  </MenuItem>
);

export function InviteMemberItem(props: Props) {
  const [field] = useField<UserInvitationParsed>(`${props.name}.${props.index}`);

  const { setFieldValue } = useFormikContext();

  const FIELD_FIRST_NAME = `${field.name}.firstname`;
  const FIELD_LAST_NAME = `${field.name}.lastname`;
  const FIELD_EMAIL = `${field.name}.email`;
  const FIELD_AFFILIATION = `${field.name}.affiliation`;
  const FIELD_AFFILIATION_DESCRIPTION = `${field.name}.affiliationDescription`;
  const FIELD_GRADUATING_YEAR = `${field.name}.graduatingYear`;

  const onAffiliationChange = (event: ChangeEvent<{ name?: string; value: unknown }>) => {
    setFieldValue(FIELD_AFFILIATION, event.target.value);
    setFieldValue(FIELD_AFFILIATION_DESCRIPTION, '');
    setFieldValue(FIELD_GRADUATING_YEAR, '');
  };

  return (
    <Container>
      <Header>
        <HeaderText variant="subtitle2">Invite #{props.index + 1}</HeaderText>

        {props.index > 0 && (
          <Button color="secondary" onClick={props.onRemove}>
            Remove
          </Button>
        )}
      </Header>

      <Grid container spacing={1}>
        <Grid item xs={12} md={6}>
          <FormTextField label="First Name" name={FIELD_FIRST_NAME} required fullWidth />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormTextField label="Last Name" name={FIELD_LAST_NAME} required fullWidth />
        </Grid>
      </Grid>

      <FormTextField label="Email" name={FIELD_EMAIL} validate={shouldBeEmail} />

      <FormSelect
        label="Affiliation"
        name={FIELD_AFFILIATION}
        required
        onChange={onAffiliationChange}
      >
        {FIELDS_CONFIG_USER.affiliation.map(mapToMenuItem)}
      </FormSelect>

      {field.value.affiliation === 'other' && (
        <FormTextField
          label="Affiliation Description"
          name={FIELD_AFFILIATION_DESCRIPTION}
          required
        />
      )}

      {field.value.affiliation === 'alumni' && (
        <FormSelect label="Graduating Year" name={FIELD_GRADUATING_YEAR} required>
          {FIELDS_CONFIG_USER.graduatingYear.map(mapToMenuItem)}
        </FormSelect>
      )}
    </Container>
  );
}
